import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';

import { dataLayerPush } from '@r1-frontend/analytics/dataLayerPush';

import { isClientSide } from '@r1-frontend/shared/helpers/ssr';

import { CHAT_ENDPOINT, IS_SANDBOX_ENVIROMENT } from '~/src/constants';
import { isPlayStation } from '~/src/helpers/mobile';
import NoSSR from '~/src/helpers/noSSR';
import { TState } from '~/src/store';
import { closeChat, loadedChat, openChat } from '~/src/store/actions/chat';

const ChatFrame = dynamic(() => import('@r1-frontend/ui-react/organisms/Chat'), { ssr: false });

interface IChat {
    enabled: boolean,
    className?: string,
}

const Chat: FC<IChat> = ({ enabled, className }: IChat) => {
    const { currentCity: city } = useSelector((state: TState) => state.city);
    const { isOpen: chatIsOpen } = useSelector((state: TState) => state.chat);

    const dispatch = useDispatch();

    const thisClientSide = isClientSide();
    const thisPlayStation = thisClientSide ? isPlayStation() : false;

    const { query } = useRouter();

    useEffect(() => {
        window.addEventListener('load', function() {
            if (typeof query.openchat === 'string') {
                dispatch(openChat());
            }
        });
    }, [query, dispatch]);

    useEffect(() => {
        if (IS_SANDBOX_ENVIROMENT) {
            document.domain = 'r-one.io';
        }
    }, [city]);

    const openChatHandler = () => {
        dataLayerPush({ event: 'online_chat', category: 'user', action: 'launched online chat' });
        dispatch(openChat());
    };

    const chatOnLoad = () => {
        dispatch(loadedChat(true));
    };

    const closeChatHandler = () => {
        dispatch(loadedChat(false));
        dispatch(closeChat());
    };

    if (thisPlayStation) {
        return null;
    }

    return (
        <NoSSR>
            <ChatFrame
                isOpen={chatIsOpen}
                open={openChatHandler}
                close={closeChatHandler}
                onLoad={chatOnLoad}
                chatLink={CHAT_ENDPOINT}
                data-test='chat'
                initiator={'B2C-DOMRU'}
                className={className}
                isHideButton={!enabled}
            />
        </NoSSR>
    );
};

export default Chat;
